import { Autocomplete, FormControl, TextField, createFilterOptions } from '@mui/material';
import { AppState, PrintLabelAttrs, labelEditorSlice } from 'cdx-common';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState, appStore } from 'store';

export const LabelItemColumnSelector = (props: { printLabel: PrintLabelAttrs, index: number; }) => {

    const sheet = useSelector((state: RootState) => state.labelEditor.currentSheet);
    const [customValue, setCustomValue] = useState(props.printLabel.items[props.index].mapping ?? '');
    const [choices, setChoices] = useState<string[]>([]);
    const printLabel = useSelector((state: AppState) => state.labelEditor.currentLabel);

    useEffect(() => {
        const choices: string[] = (printLabel?.items.filter(p => !!p.mapping).map(p => p.mapping) ?? []) as string[];
        sheet?.columns.map(p => { choices.push(p); });
        choices.push(customValue);
        setChoices(Array.from((new Set(choices)).values()));

    }, [sheet, customValue]);
    useEffect(() => {
        setCustomValue(props.printLabel.items[props.index].mapping ?? '');
    }, [props.index, props.printLabel]);



    const filter = createFilterOptions<string>();

    return <FormControl fullWidth>
        <Autocomplete
            size='small'
            fullWidth
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            value={customValue}
            options={choices}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some((option) => inputValue === option);
                if (inputValue !== '' && !isExisting) {
                    filtered.push(inputValue);
                }

                return filtered;
            }}
            onChange={(_event, newValue) => {
                if (!choices.find(p => p === newValue)) {
                    setCustomValue(newValue ?? '');
                }
                appStore.dispatch(labelEditorSlice.actions.updatePrintLabelItemAttrs({
                    index: props.index,
                    attrs: {
                        mapping: newValue ?? ''
                    }
                }));
            }}
            renderInput={(params) => <TextField {...params} label='Nom de la colonne' />}
        /></FormControl>;
};
